import styled from 'styled-components'
import { theme } from '../../styles'

export const OptList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const Opt = styled.label`
  display: flex;
  align-items: center;
  gap: 13px;
  padding: ${( { $sm } ) => ( $sm ? '12px 14px' : '14px 16px' )};
  font-size: 14.5px;
  border-radius: 12px;
  border: 1.5px solid ${( { $selected } ) => ( $selected ? theme.cores.navy : theme.cores.lineStrong )};
  background: ${( { $selected } ) => ( $selected ? theme.cores.white : theme.cores.paperAlt )};
  box-shadow: ${( { $selected } ) => ( $selected ? '0 0 0 4px rgba(38, 42, 95, 0.08)' : 'none' )};
  cursor: pointer;
  transition: border-color 0.14s ease, background 0.14s ease, box-shadow 0.14s ease;

  &:hover {
    border-color: ${theme.cores.navy};
  }
`

export const OptRadio = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid ${( { $selected } ) => ( $selected ? theme.cores.navy : theme.cores.lineStrong )};
  display: grid;
  place-items: center;
  flex-shrink: 0;

  &::after {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${( { $selected } ) => ( $selected ? theme.cores.navy : 'transparent' )};
  }
`

export const OptGrow = styled.span`
  flex: 1;
  font-weight: ${( { $sm } ) => ( $sm ? 500 : 700 )};
  color: ${theme.cores.inkDeep};
`

export const ErroMsg = styled.p`
  margin: 12px 0 0;
  font-size: 13px;
  line-height: 1.4;
  color: ${theme.cores.statusStop};
`

export const OffersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Offer = styled.div`
  display: flex;
  gap: 14px;
  padding: 16px;
  border-radius: ${theme.raio.md};
  border: 1.5px solid ${theme.cores.lineStrong};
  background: ${theme.cores.paperAlt};

  ${theme.mobile} {
    padding: 14px;
    gap: 10px;
  }
`

export const OfferIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: ${theme.cores.accentTint};
  color: ${theme.cores.accent};
  flex-shrink: 0;
`

export const OfferBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const OfferTitle = styled.h4`
  margin: 0 0 3px;
  font-size: 15px;
  font-weight: 700;
  color: ${theme.cores.inkDeep};
`

export const OfferText = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: ${theme.cores.inkSoft};

  b {
    font-weight: 700;
    color: ${theme.cores.inkDeep};
  }
`

export const OffersFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 10px;
  width: 100%;

  button {
    white-space: nowrap;
  }

  ${theme.mobile} {
    flex-wrap: wrap;

    button {
      flex: 1 1 auto;
      min-width: 0;
      min-height: 48px;
      white-space: normal;
    }
  }
`

export const ConfirmFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 8px;
  width: 100%;

  button,
  a {
    white-space: nowrap;
    padding: 12px 16px;
  }

  ${theme.mobile} {
    flex-direction: column-reverse;
    gap: 10px;

    button,
    a {
      width: 100%;
      min-height: 48px;
      padding: 12px 20px;
      white-space: normal;
    }
  }
`

export const OfferListaTitulo = styled.p`
  margin: 8px 0 0;
  font-size: 13px;
  font-weight: 700;
  color: ${theme.cores.inkDeep};
`

export const OfferLista = styled.ul`
  margin: 0;
  padding-left: 18px;
  font-size: 13px;
  line-height: 1.6;
  color: ${theme.cores.inkSoft};

  li::marker {
    color: ${theme.cores.accent};
  }
`

export const Coupon = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 6px;

  input {
    flex: 1;
  }

  ${theme.mobile} {
    flex-direction: column;
    align-items: stretch;

    input {
      width: 100%;
    }
  }
`

export const Callout = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 11px;
  background: ${theme.cores.accentTint};
  border: 1px solid #EAD4B6;
  color: #6E4A12;
  margin-bottom: 18px;
  font-size: 13.5px;
  line-height: 1.5;
`

export const CalloutTexto = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  p {
    margin: 0;
  }
`

export const SuccessBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
  padding: 14px 6px 4px;

  h2 {
    margin: 0;
    color: ${theme.cores.navy};
    font-size: 24px;
  }

  p {
    margin: 0;
    color: ${theme.cores.inkSoft};
    font-size: 14px;
    line-height: 1.5;
    max-width: 380px;
  }
`

export const SuccessSeal = styled.div`
  width: 78px;
  height: 78px;
  border-radius: 50%;
  background: ${( { $stop } ) => ( $stop
    ? 'radial-gradient(circle at 35% 30%, #C9605A, #B23A33)'
    : `radial-gradient(circle at 35% 30%, ${theme.cores.accentSoft}, ${theme.cores.accent})` )};
  box-shadow: ${( { $stop } ) => ( $stop
    ? '0 8px 22px rgba(178, 58, 51, 0.4)'
    : '0 8px 22px rgba(213, 112, 27, 0.4)' )};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 38px;
    height: 38px;
  }
`
